<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2021-05-13 19:49:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/securitycheck/index.vue
-->
<template>
  <div class="security">
    <title-bar-back :title="'安全检测'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 上部信息 -->
    <top-per />
    <!-- 手机号验证码 -->
    <code-field @input="input" @senderCode="senderCode" />
    <!-- button -->
    <div
      :class="verifyCode.length === 6 ? 'go_btn' : 'un_btn'"
      class="font14 font_weight500 colof btn"
      @click="goNext"
    >
      下一步
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const TopPer = () => import("./components/TopPer").then(m => m.default || m);
const CodeField = () =>
  import("./components/CodeField").then(m => m.default || m);
export default {
  components: {
    TitleBarBack,
    TopPer,
    CodeField
  },
  data() {
    return {
      verifyCode: ""
    };
  },
  computed: {
    truePhone() {
      return this.$store.getters.truePhone;
    },
    getUserInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  created() {
    this.getPhone();
    if (!this.getUserInfo.username) {
      this.getData();
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    input(value) {
      this.verifyCode = value;
    },
    // 发送验证码
    senderCode() {
      const data = {
        phone: this.truePhone,
        kind: "ChangePwd"
      };
      if (this.$route.query.where === "modifyPhone") {
        data.kind = "ChangePhone";
      } else {
        data.kind = "ChangePwd";
      }
      this.$store
        .dispatch("login/sendSms", {
          params: data
        })
        .then(() => {})
        .catch(err => {
          this.errorMsg = err.message;
        });
    },
    // 获取真实手机号 getUserPhone
    getPhone() {
      this.$store
        .dispatch("mine/getUserPhone")
        .then(() => {})
        .catch(() => {});
    },
    // 获取用户数据
    getData() {
      // getUserInfo
      this.$store
        .dispatch("mine/getUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    goNext() {
      if (this.verifyCode.length < 6) {
        return;
      }
      if (this.$route.query.where === "modifyPhone") {
        // 修改手机号
        this.$router.push("/mine/modifyphone");
      } else if (this.$route.query.where === "modifyPass") {
        const params = {
          code: this.verifyCode,
          kind: "ChangePwd",
          phone: this.truePhone
        };
        this.$store
          .dispatch("login/checkVerifyCode", {
            params
          })
          .then(() => {
            this.$router.push("/mine/modifyLoginPass");
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.security {
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .btn {
    margin: 16px 12px 0;
    line-height: 40px;
    border-radius: 20px;
  }
  .un_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    opacity: 0.5;
  }
  .go_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  }
}
</style>
